import { render, staticRenderFns } from "./SlopeFormDataTable.vue?vue&type=template&id=52658985&"
import script from "./SlopeFormDataTable.vue?vue&type=script&lang=js&"
export * from "./SlopeFormDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports